import { CartActions } from './../constants/actionType'
import * as chat from './../service/aimsChat';
const initialState = {
    cartHeader: [],
    cartData: [],
    cartResponse: [],
    isCartOpen: false,
    cartOfferToggle: {
        isAutopayOffer: true,
        isSpecialOffer: true,
        isSpecialOneTimeOffer: true,
        isSpecialMonthlyOffer: true,
    },
    splitBillTab: 0,
    cartOrderDetail: null,
    cartOrderProperty: null,
    autoPayinCart: false,
    advantageOfferinCart: false,
    isCartUpdated: false,
    isCartSaveOnUpdate: false,
    isToolTip: false,
    isFiosSetupFee: "",
    isIONT: false,
    iONTEligibleAmazon: false,
    isCartDataSentToDTM: true,
    isShippingFee:false,
    atvQual:false,
    fullCartToggle : 'Y',
    showDueMonthlyDetails: false,
    showOneTimeCharges: false,
    showMonthlyCharges: false,
    showSavingsDailog: false
}

function cart(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_CART':
            if (action.value !== undefined && action.value.cartData !== undefined && action.value.cartData !== null) {
                try {
                    if (action.value.chatRequestIdleEnabled && window.requestIdleCallback) {
                        window.requestIdleCallback(() => chat.setCartChat(action.value.cartData, false));
                    } else {
                      chat.setCartChat(action.value.cartData, false); // -- Commenting off as remove product isn't working(when cartData is null). Please move this to respective action method
                    }
                  } catch (ex) {
                    console.log("requestIdleCallback exception", JSON.stringify(ex));
                  }
            }
            return Object.assign({}, state, {
                cartResponse: action.value.cartResponse,
                cartHeader: action.value.cartHeader,
                cartData: action.value.cartData,
                cartOrderDetail: action.value.cartOrderDetail,
                cartOrderProperty: action.value.cartOrderProperty
            })
        case CartActions.toggleCart:
            return Object.assign({}, state, {
                isCartOpen: !state.isCartOpen
            })
        case CartActions.clearBuildProductState:
            return initialState
        case CartActions.toggleOffers:
            if (action.value === "AutoPayToggle") {
                let autopayOffer = Object.assign({}, state.cartOfferToggle, {
                    isAutopayOffer: !state.cartOfferToggle.isAutopayOffer,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: autopayOffer
                })
            }
            if (action.value === "SpecialOfferToggle") {
                let specialOffer = Object.assign({}, state.cartOfferToggle, {
                    isSpecialOffer: !state.cartOfferToggle.isSpecialOffer,
                    isSpecialOneTimeOffer: true,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: specialOffer,
                    showOneTimeCharges: !action.value,
                })
            }
            if (action.value === "SpecialOfferOneTimeToggles") {
                let specialOffer = Object.assign({}, state.cartOfferToggle, {
                    isSpecialOneTimeOffer: !state.cartOfferToggle.isSpecialOneTimeOffer,
                    isSpecialOffer: true,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: specialOffer,
                    showOneTimeCharges: !action.value,
                })
            }
            break;
            case 'TOGGLE_ONE_TIME_CHARGES':
                let specialOffer = Object.assign({}, state.cartOfferToggle, {
                    isSpecialOneTimeOffer: true,
                    isSpecialOffer: true,
                })
                return Object.assign({}, state, {
                    showOneTimeCharges: !action.value,
                    cartOfferToggle: specialOffer,
                })
        case 'TOGGLE_MONTHLY_CHARGES':
            let specialmonthlyOffer = Object.assign({}, state.cartOfferToggle, {
                isSpecialMonthlyOffer: true,
                isSpecialOffer: true,
            })
            return Object.assign({}, state, {
                showMonthlyCharges: !action.value,
                cartOfferToggle: specialmonthlyOffer,
            })
        case "EMPTYCARTSTATE":
            return initialState
        case CartActions.splitBillTab:
            return Object.assign({}, state, {
                splitBillTab: action.value
            })
        case CartActions.clearcartstate:
            return initialState
        case 'AUTOPAYINCART':
            return Object.assign({}, state, {
                autoPayinCart: action.value
            })
        case 'ADVANTAGEOFFERINCART':
            return Object.assign({}, state, {
                advantageOfferinCart: action.value
            })
        case 'ISCARTUPDATED':
            return Object.assign({}, state, {
                isCartUpdated: action.value
            })
        case 'CART_SAVE_ON_UPDATE':
            return Object.assign({}, state, {
                isCartSaveOnUpdate: action.value
            })
        case 'CART_UPDATE':
            return { ...state, 
                isCartUpdated: action.value.isCartUpdated,
                isCartSaveOnUpdate: action.value.isCartSaveOnUpdate
             };
        case 'TOGGLE_TOOLTIP':
            return Object.assign({}, state, {
                isToolTip: !state.isToolTip
            })
        case 'FIOSSETUPFEE':
            return Object.assign({}, state, {
                isFiosSetupFee: action.value
            })
        case 'IONT_STATUS':
            return Object.assign({}, state, {
                isIONT: action.value
            })
        case "IONT_ELIGIBLE_AMAZON":
            return (Object.assign({}, state, {
                iONTEligibleAmazon: action.value
            }))
        case 'IS_CART_SENT_TO_DTM':
            return Object.assign({}, state, {
                isCartDataSentToDTM: action.value
            })
        case 'ISSHIPPINGFEE':
            return Object.assign({}, state, {
                isShippingFee: action.value
        })    
        case 'UPDATE_CLEARCART':
            return initialState
        case 'ANDROID_TV_STB':
            return Object.assign({}, state, {
                atvQual: action.value
            })
        case 'FULL_CART_TOGGLE':
            return Object.assign({}, state, {
                fullCartToggle: action.value
            })
        case 'SHOW_DUE_MONTHLY_DETAILS':
            return Object.assign({}, state, {
                showDueMonthlyDetails: !action.value
            })
        case 'SHOW_SAVINGS_DAILOG':
            return Object.assign({}, state,{
                showSavingsDailog: action.value
            })
        default:
            return state
    }
}


export default cart
